import { Builder, withChildren } from '@builder.io/react';

import _CentralizedHero from './index.tsx';

const CentralizedHero = withChildren(_CentralizedHero);

const defaultHeroInputs = [
  {
    name: 'title',
    type: 'string',
    defaultValue: 'Retail & eCommerce'
  },
  {
    name: 'location',
    type: 'object',
    subFields: [
      {
        name: 'name',
        type: 'string'
      },
      {
        name: 'date',
        type: 'string'
      }
    ]
  },
  {
    name: 'product',
    type: 'string'
  },
  { name: 'scaleLogo', type: 'boolean', defaultValue: true },
  {
    name: 'subtitle',
    type: 'longText',
    defaultValue: 'Powering eCommerce with AI solutions and accurate, robust, and up-to-date data.'
  },
  { name: 'webgl', type: 'boolean', defaultValue: false },
  { name: 'scaleLogo', type: 'boolean', defaultValue: false },
  {
    name: 'addProductLogo',
    type: 'boolean',
    defaultValue: false
  },
  {
    showIf: "options.get('addProductLogo')",
    name: 'logo',
    type: 'object',
    subFields: [
      {
        name: 'asIcon',
        type: 'boolean',
        defaultValue: true
      },
      {
        name: 'src',
        type: 'file',
        allowedFileTypes: ['jpeg', 'svg', 'png'],
        showIf: "options.get('asIcon')"
      },
      {
        name: 'alt',
        type: 'string',
        showIf: "options.get('asIcon')"
      },
      {
        name: 'width',
        type: 'number'
      },
      {
        name: 'height',
        type: 'number'
      },
      {
        name: 'widthMobile',
        type: 'number',
        showIf: "options.get('asIcon')"
      },
      {
        name: 'heightMobile',
        type: 'number',
        showIf: "options.get('asIcon')"
      },
      {
        name: 'scene',
        type: 'string',
        showIf: "!options.get('asIcon')"
      }
    ]
  },
  {
    name: 'useHubSpotCTA',
    type: 'boolean',
    defaultValue: 'true'
  },
  {
    showIf: `options.get('useHubSpotCTA') === false`,
    name: 'formId',
    type: 'string'
  },
  {
    showIf: `options.get('useHubSpotCTA') === true`,
    name: 'cta',
    type: 'object',
    subFields: [
      {
        name: 'buttons',
        type: 'list',
        subFields: [
          {
            name: 'text',
            type: 'string',
            defaultValue: 'Get Started'
          },
          {
            name: 'href',
            type: 'url',
            defaultValue: '/sales'
          },
          {
            name: 'type',
            type: 'string',
            defaultValue: 'primary',
            enum: ['primary', 'secondary', 'inverted']
          },
          {
            name: 'variant',
            type: 'string',
            defaultValue: 'default',
            enum: ['default', 'transparent']
          }
        ]
      },
      {
        name: 'addButtonModal',
        type: 'boolean',
        defaultValue: false
      },
      {
        showIf: "options.get('addButtonModal')",
        name: 'hubspotModal',
        type: 'object',
        subFields: [
          {
            name: 'formId',
            type: 'string'
          },
          {
            name: 'sfdcCampaignId',
            type: 'string'
          },
          {
            name: 'label',
            type: 'string'
          },
          {
            name: 'type',
            type: 'string',
            defaultValue: 'primary',
            enum: ['primary', 'secondary']
          },
          {
            name: 'variant',
            type: 'string',
            defaultValue: 'default',
            enum: ['default', 'transparent']
          }
        ]
      }
    ]
  }
];

Builder.registerComponent(CentralizedHero, {
  name: 'Centralized Hero Image',
  inputs: [
    ...defaultHeroInputs,
    {
      name: 'image',
      type: 'object',
      subFields: [
        {
          name: 'src',
          type: 'file',
          allowedFileTypes: ['jpeg', 'svg', 'png', 'gif'],
          defaultValue:
            'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F9245b80daf6e46258858cabd5994367f'
        },
        {
          name: 'alt',
          type: 'string',
          defaultValue: 'set alt'
        },
        {
          name: 'width',
          type: 'number',
          defaultValue: 1630
        },
        {
          name: 'height',
          type: 'number',
          defaultValue: 1336
        },
        { name: 'frame', type: 'boolean', defaultValue: false }
      ],
      defaultValue: {
        src: 'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F9245b80daf6e46258858cabd5994367f',
        alt: 'set alt',
        width: 1630,
        height: 1336,
        frame: false
      }
    }
  ],
  defaultChildren: [
    {
      component: {
        name: 'Header'
      }
    },
    {
      component: {
        name: 'Navigation',
        options: {
          title: {
            text: 'Product',
            href: '/'
          },
          links: [
            {
              text: 'Item 1',
              href: '/item1'
            },
            {
              text: 'Item 2',
              href: '/item2'
            },
            {
              text: 'Item 3',
              href: '/item3'
            }
          ],
          theme: 'dark'
        }
      }
    }
  ]
});

Builder.registerComponent(CentralizedHero, {
  name: 'Centralized Hero Video',
  inputs: [
    ...defaultHeroInputs,
    {
      name: 'video',
      type: 'object',
      subFields: [
        {
          name: 'src',
          type: 'string',
          defaultValue: 'https://stream.mux.com/aU5MGkW79Jk400UFz6pqDKlzOYUOiWwAO.m3u8'
        },
        {
          name: 'poster',
          type: 'string'
        },
        { name: 'width', type: 'number', defaultValue: 1920 },
        { name: 'height', type: 'number', defaultValue: 1080 },
        { name: 'frame', type: 'boolean', defaultValue: false },
        { name: 'autoplay', type: 'boolean', defaultValue: true },
        { name: 'controls', type: 'boolean', defaultValue: false },
        { name: 'loop', type: 'boolean', defaultValue: true },
        { name: 'muted', type: 'boolean', defaultValue: false }
      ],
      defaultValue: {
        src: 'https://stream.mux.com/aU5MGkW79Jk400UFz6pqDKlzOYUOiWwAO.m3u8',
        width: 1920,
        height: 1080,
        frame: false,
        autoplay: true,
        controls: false,
        loop: true,
        muted: true
      }
    }
  ],
  defaultChildren: [
    {
      component: {
        name: 'Header'
      }
    },
    {
      component: {
        name: 'Navigation',
        options: {
          title: {
            text: 'Product',
            href: '/'
          },
          links: [
            {
              text: 'Item 1',
              href: '/item1'
            },
            {
              text: 'Item 2',
              href: '/item2'
            },
            {
              text: 'Item 3',
              href: '/item3'
            }
          ],
          theme: 'dark'
        }
      }
    }
  ]
});

Builder.registerComponent(CentralizedHero, {
  name: 'Centralized Hero Spline',
  inputs: [
    ...defaultHeroInputs,
    {
      name: 'scene',
      type: 'string',
      defaultValue: 'https://prod.spline.design/NX6jhAYfLVq7ULPP/scene.splinecode'
    },
    {
      name: 'mobileImage',
      type: 'object',
      subFields: [
        {
          name: 'src',
          type: 'file',
          allowedFileTypes: ['jpeg', 'svg', 'png']
        },
        {
          name: 'alt',
          type: 'string'
        },
        {
          name: 'width',
          type: 'number'
        },
        {
          name: 'height',
          type: 'number'
        }
      ]
    }
  ],
  defaultChildren: [
    {
      component: {
        name: 'Header'
      }
    },
    {
      component: {
        name: 'Navigation',
        options: {
          title: {
            text: 'Product',
            href: '/'
          },
          links: [
            {
              text: 'Item 1',
              href: '/item1'
            },
            {
              text: 'Item 2',
              href: '/item2'
            },
            {
              text: 'Item 3',
              href: '/item3'
            }
          ],
          theme: 'dark'
        }
      }
    }
  ]
});

Builder.registerComponent(CentralizedHero, {
  name: 'Centralized Hero Content',
  inputs: [
    ...defaultHeroInputs,
    {
      name: 'content',
      type: 'string',
      enum: ['llma'],
      defaultValue: ['llma']
    }
  ],
  defaultChildren: [
    {
      component: {
        name: 'Header'
      }
    },
    {
      component: {
        name: 'Navigation',
        options: {
          title: {
            text: 'Product',
            href: '/'
          },
          links: [
            {
              text: 'Item 1',
              href: '/item1'
            },
            {
              text: 'Item 2',
              href: '/item2'
            },
            {
              text: 'Item 3',
              href: '/item3'
            }
          ],
          theme: 'dark'
        }
      }
    }
  ]
});
